import React, { useState, useEffect } from 'react';
import Lodinggif from "../assets/Department_Icons/Loading_gif.gif";

const CenterSpinner = ({   className }) => {
    const [showLoader, setShowLoader] = useState(true);
useEffect(() => {
    const timer = setTimeout(() => {
      setShowLoader(false); // Hide the loader after 3 seconds
    }, 2000); 
    return () => clearTimeout(timer); // cleanup on unmount
  }, []);
  if (!showLoader) return null;

  return (
    <div
      className={`spinner-element ${className ?? 'spinner-center'}`}
      style={{
        backgroundColor: 'white',
        width: '100vw',
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999,
        position: 'fixed',
        top: 0,
        left: 0
      }}
    >
      <img
        src={Lodinggif}
        alt="Loading..."
        className="gif-loader"
        style={{ width: '80px', height: '80px' }}
      />
    </div>
  );
};

export default CenterSpinner;
